// @ts-nocheck


import { notificationType } from '../enum';
import { fetchRequest } from './index';

/**
 * Проверка уведомлений.
 * Сервер отвечает 200 с пустым телом, если уведомлений нет,
 * и 400 с текстом уведомления, если они есть.
 * Возвращает null, если уведомлений нет; иначе выбрасывает ошибку с текстом.
 */
export const notification = async (type) => {
  try {
    await fetchRequest.get(`/notify/notification?notificationType=${type}`);
  } catch (error) {
    // Пустое тело при 200: response.json() падает с SyntaxError
    if (error instanceof SyntaxError) return null;
    if (error instanceof Error) throw error;
    throw new Error(`Не удалось получить уведомления ${notificationType[type]}`);
  }
  return null;
};

export default { notification };
